import { FC } from "react";
import { IResolveFATServiceOrderFormSchema } from "./schema";
import lodash from "lodash";
import {PaperClipIcon} from "@heroicons/react/20/solid";
import {FilePreview} from "components/cards";
import {DocumentTextIcon} from "@heroicons/react/24/outline";

const ProductInfoSummary: FC<{ data: IResolveFATServiceOrderFormSchema["extraInfo"], values: IResolveFATServiceOrderFormSchema, }> = ({ data, values }) => (
  <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200">
    <div className=''>
      <span className="text-xs font-light">Product Information</span>
      <div className='grid grid-cols-3 gap-6 mt-2'>
        <div className="col-span-3">
          <span className="block text-sm font-light text-gray-700">
            Observations
          </span>
          <div className="whitespace-pre mt-1 block w-full sm:text-sm">
            {data?.observations?.join("\n") || "N/A"}
          </div>
        </div>
        <div className="col-span-3 col-start-1">
          <span className="block text-sm font-light text-gray-700">
            Conclusion
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.conclusion || "N/A"}
          </div>
        </div>
        <div className="col-span-3 col-start-1">
          <span className="block text-sm font-light text-gray-700">
            Recommendations
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.recommendations || "N/A"}
          </div>
        </div>
        <div className="sm:col-span-3">
          <dt className="text-sm font-medium text-gray-500">Supporting Documents</dt>
          <dd className="mt-1 text-sm text-gray-900">
            {data.supportingImageUrls?.length ? (
              <ul className="divide-y divide-gray-200 rounded-md border border-gray-200">
                {data.supportingImageUrls?.map(
                  (documentUrl, idx) => {
                    const documentName = lodash
                      .chain(documentUrl)
                      .split("/")
                      .last()
                      .value();
                    return (
                      <li
                        key={idx}
                        className="flex items-center justify-between py-3 pl-3 pr-4 text-sm"
                      >
                        <div className="flex w-0 flex-1 items-center">
                          <PaperClipIcon
                            aria-hidden="true"
                            className="h-5 w-5 flex-shrink-0 text-gray-400"
                          />
                          <span className="ml-2 w-0 flex-1 truncate">
                            {documentName}
                          </span>
                        </div>
                        <div className="ml-4 flex-shrink-0 space-x-3">
                          <FilePreview url={documentUrl} />
                          <a
                            href={documentUrl}
                            download={documentName}
                            className="font-medium text-primary-600 hover:text-primary-500"
                          >
                            Download
                          </a>
                        </div>
                      </li>
                    );
                  }
                )}
              </ul>
            ) : (
              <div className="block w-full rounded-lg border-2 border-dashed border-gray-400 p-6 text-center">
                <DocumentTextIcon
                  aria-hidden="true"
                  strokeWidth={1}
                  className="mx-auto text-sm h-8 w-8 text-gray-500"
                />
                <span className="mt-3 block text-sm text-gray-500">
                      No Files Were Attached
                    </span>
              </div>
            )}
          </dd>
        </div>
        <div className="sm:col-span-3">
          <dt className="text-sm font-medium text-gray-500">Routine Test Reports</dt>
          <dd className="mt-1 text-sm text-gray-900">
            {data.routineTestReports?.length ? (
              <ul className="divide-y divide-gray-200 rounded-md border border-gray-200">
                {data.routineTestReports?.map(
                  (documentUrl, idx) => {
                    const documentName = lodash
                      .chain(documentUrl)
                      .split("/")
                      .last()
                      .value();
                    return (
                      <li
                        key={idx}
                        className="flex items-center justify-between py-3 pl-3 pr-4 text-sm"
                      >
                        <div className="flex w-0 flex-1 items-center">
                          <PaperClipIcon
                            aria-hidden="true"
                            className="h-5 w-5 flex-shrink-0 text-gray-400"
                          />
                          <span className="ml-2 w-0 flex-1 truncate">
                            {documentName}
                          </span>
                        </div>
                        <div className="ml-4 flex-shrink-0 space-x-3">
                          <FilePreview url={documentUrl} />
                          <a
                            href={documentUrl}
                            download={documentName}
                            className="font-medium text-primary-600 hover:text-primary-500"
                          >
                            Download
                          </a>
                        </div>
                      </li>
                    );
                  }
                )}
              </ul>
            ) : (
              <div className="block w-full rounded-lg border-2 border-dashed border-gray-400 p-6 text-center">
                <DocumentTextIcon
                  aria-hidden="true"
                  strokeWidth={1}
                  className="mx-auto text-sm h-8 w-8 text-gray-500"
                />
                <span className="mt-3 block text-sm text-gray-500">
                  No Files Were Attached
                </span>
              </div>
            )}
          </dd>
        </div>
      </div>
    </div>
  </div>
);

export default ProductInfoSummary;